module.exports = "\n<div myPreloader class=\"preloaderbar hide\"><span class=\"bar\"></span></div>\n<div id=\"app-main\" class=\"app-main full-height fixed-header nav-collapsed sidebar-sm\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 3